import { Logger, areEqualBinaries, collect, toStreamPartID, wait } from '@streamr/utils';
import { convertStreamMessageToMessage } from '../Message';
import { StreamrClientError } from '../StreamrClientError';
const logger = new Logger('waitForStorage');
export const waitForStorage = async (message, opts, resends, streamStorageRegistry) => {
    if (!message) {
        throw new StreamrClientError('waitForStorage requires a Message', 'INVALID_ARGUMENT');
    }
    const matcher = opts.messageMatchFn ?? ((msgTarget, msgGot) => (areEqualBinaries(msgTarget.signature, msgGot.signature)));
    const start = Date.now();
    let last;
    let found = false;
    while (!found) {
        const duration = Date.now() - start;
        if (duration > opts.timeout) {
            logger.debug('Timed out waiting for storage to contain message', {
                expected: message.streamMessage.messageId,
                lastReceived: last?.map((l) => l.messageId),
            });
            throw new Error(`timed out after ${duration}ms waiting for message`);
        }
        const getStorageNodes = (streamId) => streamStorageRegistry.getStorageNodes(streamId);
        const resendStream = await resends.resend(toStreamPartID(message.streamId, message.streamPartition), { last: opts.count }, getStorageNodes);
        last = await collect(resendStream);
        for (const lastMsg of last) {
            if (matcher(message, convertStreamMessageToMessage(lastMsg))) {
                found = true;
                logger.debug('Found matching message');
                return;
            }
        }
        logger.debug('Retry after delay (matching message not found)', {
            expected: message.streamMessage.messageId,
            'last-3': last.slice(-3).map((l) => l.messageId),
            delayInMs: opts.interval
        });
        await wait(opts.interval);
    }
};
//# sourceMappingURL=waitForStorage.js.map